import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import moment from 'moment';

import authContext from '../context/authContext/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAppointmentAction, getAppointmentsAction } from '../redux/actions/appointmentAction';
import UserDetailsModal from '../components/modals/UserDetailsModal';

const Appointments = () => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)

  const [state, setCompleteState] = useState({ reqUserId: '', showUserDetailsModal: false, })
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const { loading, completedAppointments, upComingAppointments } = useSelector((state) => state.appointments);

  const getAppointments = async () => {
    const config = getConfig()
    dispatch(getAppointmentsAction(config))
  }

  useEffect(() => {
    getAppointments();
  }, []);

  const deleteAppointment = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      reverseButtons: true // 👈 this does the trick
    }).then((result) => {
      if (result.isConfirmed) {
        confirmDeleteAppointment(id);
      }
    });
  }

  const confirmDeleteAppointment = async (id) => {
    const data = { id }
    const config = getConfig();
    dispatch(deleteAppointmentAction(data, config, getAppointments))
  }

  const onUserIdClick = (userId) => {
    setState({ reqUserId: userId, showUserDetailsModal: true })
  }


  return (
    <div className="main-container">
      <div className="card-box mb-30">
        <div className='table-card-header'>
          <div className='d-flex align-items-center'>
            <h2 className="h4 mb-0 py-2">GleamDesk Appointments</h2>
            {loading ? (
              <div className='ml-3'>
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="overflow-x-scroll">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">Title</th>
                <th scope="col">Phone</th>
                <th scope="col">Note</th>
                <th scope="col">Time</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {(upComingAppointments || []).map((appointment) => {
                const { user, title, phone, note, dateTime, _id, userId } = appointment;
                return (
                  <tr key={_id}>
                    <th scope="row" className='name cursor-pointer' onClick={() => onUserIdClick(userId)}>{user}</th>
                    <td>{title}</td>
                    <td>{phone || '-'}</td>
                    <td><span>{note || '-'}</span></td>
                    <td>{moment(dateTime).format("dddd, MMMM Do YYYY, h:mm a")}</td>
                    <td>
                      <span className='badge gleamdesk-orange badge-pill px-3 py-2'>Upcoming</span>
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-danger btn-sm my-1 mx-1' onClick={() => deleteAppointment(_id)}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}

              {(completedAppointments || []).map((appointment) => {
                const { user, title, phone, note, dateTime, _id, userId } = appointment;
                return (
                  <tr key={_id}>
                    <th scope="row" className='name cursor-pointer' onClick={() => onUserIdClick(userId)}>{user}</th>
                    <td>{title}</td>
                    <td>{phone || '-'}</td>
                    <td>{note || '-'}</td>
                    <td>{moment(dateTime).format("dddd, MMMM Do YYYY, h:mm a")}</td>
                    <td>
                      <span className='badge badge-success badge-pill px-3 py-2'>Completed</span>
                    </td>
                    <td className='actions-container'>
                      <button className='btn btn-danger btn-sm my-1 mx-1' disabled onClick={() => deleteAppointment(_id)}>
                        <i className='fa fa-trash' />
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <UserDetailsModal
        isOpen={state.showUserDetailsModal}
        toggle={() => setState({ reqUserId: '', showUserDetailsModal: false })}
        reqUserId={state.reqUserId}
      />
    </div>
  )
}

export default Appointments